import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import useLogout from '../../../hooks/useLogout';
import Prompt from '../../Prompt/Prompt';
import { promptTitleCapitalize } from '../shared.scss';

import {
  TXTCLI_Logout,
  TXTSRV_According_to_the_records_held__ELL_1,
  TXTWCL_You_are_currently_excluded_fro_ELL
} from './DKBlacklistError.messages.json';

const DKBlacklistError: React.FC = () => {
  const logout = useLogout();

  return (
    <Prompt
      classes={{ title: promptTitleCapitalize }}
      variant="default"
      title={{ translation: TXTWCL_You_are_currently_excluded_fro_ELL }}
      noCloseButton
      primaryButton={{ translation: TXTCLI_Logout }}
      onPrimaryButtonClick={() => logout()}
    >
      <Translation
        tagName="p"
        {...TXTSRV_According_to_the_records_held__ELL_1}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.DKRofusBbr}>{msg}</ResolverLink>
          )
        }}
      />
    </Prompt>
  );
};

export default DKBlacklistError;
